/**
 * Copyright (c) 2010-2026 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export default {
    production: false,
    debug: true,
    baseHref: "",
    apiBase: 'https://sanrafael.brianschantz.me'
};
